module.exports = __webpack_public_path__ + "img/main_logo.7d6738e1.png";